import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-no-data-component',
  templateUrl: './nodata.component.html',
  imports: [CommonModule],
  styleUrls: ['./nodata.component.scss']
})
export class NoDataComponent {}
